import axios from 'axios';
import config from '../config';
import { getUserToken } from '../utils/helper';

export const GET_INSURANCE_DROPDOWN = 'GET_INSURANCE_DROPDOWN';
export const GET_INSURANCE_DROPDOWN_SUCCESS = 'GET_INSURANCE_DROPDOWN_SUCCESS';
export const GET_INSURANCE_DROPDOWN_FAIL = 'GET_INSURANCE_DROPDOWN_FAIL';
export const GET_INSURANCE_DROPDOWN_RESET = 'GET_INSURANCE_DROPDOWN_RESET';

export const getInsuranceDropdown = (params) => {
	return {
		type: GET_INSURANCE_DROPDOWN,
		params,
	};
};

export const getInsuranceDropdownSuccess = (response) => {
	return {
		type: GET_INSURANCE_DROPDOWN_SUCCESS,
		response,
	};
};

export const getInsuranceDropdownFail = (response) => {
	return {
		type: GET_INSURANCE_DROPDOWN_FAIL,
		response,
	};
};

export const getInsuranceDropdownReset = () => {
	return {
		type: GET_INSURANCE_DROPDOWN_RESET,
	};
};

export const getInsuranceDropdownApi = (data) => {
	return (dispatch) => {
		dispatch(getInsuranceDropdown());
		axios
			.get(`${config.api.base_url}/insurance-companies/dropdown`, {
				params: data,
				headers: {
					Authorization: 'Bearer ' + getUserToken(),
				},
			})
			.then((response) => {
				const getInsuranceDropdownData = response.data;
				dispatch(getInsuranceDropdownSuccess(getInsuranceDropdownData));
			})
			.catch((error) => {
				const errorMsg = error.message;
				dispatch(getInsuranceDropdownFail(errorMsg));
			});
	};
};
